export default "__VITE_ASSET__ByR1hlCW__"